import { AxiosAuth } from "./config/axiosAuth.instance"

export const getManagementWalletRechargeAPI = () => {
   return AxiosAuth.get("recharge-package").then((response) => ({ response }))
}
